import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";

import { Slideshow } from "../models/slideshow";
import { Corsi } from "../models/corsi";

@Injectable({
  providedIn: "root",
})
export class CorsiUploadService extends CrudService<Corsi, number> {
  constructor(protected _http: HttpClient) {
    super(_http, `${environment.baseUrl}/corsi`);
  }
}
